import { render, staticRenderFns } from "./course.vue?vue&type=template&id=ab0e4914&scoped=true&xmlns%3A=true"
import script from "./course.vue?vue&type=script&lang=js"
export * from "./course.vue?vue&type=script&lang=js"
import style0 from "./course.vue?vue&type=style&index=0&id=ab0e4914&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab0e4914",
  null
  
)

export default component.exports